import { getItemById } from '../../selectors/items/get-item-by-id';
import { getLowestItemPrice, isDiscountOrMemberRewardItemPrice } from './item-price-utils';
import { isNormalItem } from './item-type-utils';
export const isLowestItemPriceRestricted = (sellableItem) => {
    const item = getItemById(sellableItem.itemId);
    if (!item)
        throw new Error(`Cannot find item with ID: ${sellableItem.itemId}.`);
    if (!isNormalItem(item))
        return false; // Only supporting normal item as sellable items with prices.
    const lowestItemPrice = getLowestItemPrice(sellableItem.prices);
    return !!lowestItemPrice && isDiscountOrMemberRewardItemPrice(lowestItemPrice);
};
